<ca-conversation-standard-call-list
  *ngIf="standardListVisible"
  (conversationIdChange)="onConversationIdChanged($event)"
  (dataLoaded)="onDataLoaded()"
  [compactPlayer]="compactPlayer"></ca-conversation-standard-call-list>
